
import { DatePipe, JsonPipe } from '@angular/common'
import { CreateTicketFormFields } from '../tickets/createTicketFormFields'
import { TicketsService, EquipmentService, UserService,MessageService} from '../../services/'
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { BartTicketValidate } from 'src/app/models/tickets/bart.ticket.validate'
import {TicketDetails } from './TicketDetails';
import {UserDetail,AccessUserInfo } from '../user/UserInfo';
@Injectable({
  providedIn: 'root'
})

export class BartTicketSave {
  public userid: number;
  public userInfo:UserDetail;
  private formFields: CreateTicketFormFields;
  constructor
    (
      private _ticketService: TicketsService,
      private _userService: UserService,
      private router:Router,
      private _ticketValidate: BartTicketValidate,
      private _messageService:MessageService
    ) 
    {
      this.userInfo=AccessUserInfo.getUserInfo();
      this._ticketService.getTicketGlobalData().subscribe((Result: any) => {
        this.formFields = Result; //Get Latest Update value from here
        this.userid = this.userInfo.userId;
      },
        (error) => {
          // handle error here
        }
      );
    }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////// SAVE TICKET MASTER FUNCTION /////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async saveTicket(msg: boolean,fnTicketSaveCallBack) {
    var batchTicket = this.formFields.isBatchTicket;
    let TICKETID = this.formFields.TicketId
    if (TICKETID == undefined) {
     await this.createTicket(msg,fnTicketSaveCallBack);
    } else {
      if (TICKETID == undefined) {
        //ERRORED OUT
        fnTicketSaveCallBack(false);
      } else {
        if (this.formFields.isBatchTicket == true) 
        {
         this.saveBatchTicket(msg,fnTicketSaveCallBack);
        } else if (this.formFields.isBatchTicket == false) {
        await  this.saveStandardTicket(msg,fnTicketSaveCallBack);
        } else {
          fnTicketSaveCallBack(false);
          this._messageService.showAlertMessage('Error: Cannot determine if ticket is batchable.');
        }
      }
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////// CREATE A TICKET /////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  public createTicket(msg: boolean,fnTicketSaveCallBack) {   
    var CREATETICKET = {
      workTypeId: this.formFields.selectedWorkTypeId,
      isScheduledFlag: this.formFields.ScheduledRadioButtonselectedValue == 'no' ? 0 : this.formFields.ScheduledRadioButtonselectedValue == 'yes' ? 1 : 0,
      facilityMasterId: this.formFields.selectedFacilityId,
      equipmentId: this.formFields.SelectedEquipmentID,
      dateServiceRequested: this.formFields.srRequestedDate,
      dateServiceBegan: this.formFields.srBeginDate,
      UserID: this.userid
    };
    this._ticketService.createTicket(JSON.stringify({ CREATETICKET })).subscribe((Result: any) => {
      if (Result.length > 0) {
        this.formFields.TicketId = Result[0].TicketID;
        this.formFields.ticketNumber = Result[0].TicketNumber;
        if (this.formFields.isBatchTicket == false) {
          this.saveStandardTicket(msg,fnTicketSaveCallBack);
        }
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////// SAVE STANDARD TICKET ////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  public saveStandardTicket(msg:any,fnTicketSaveCallBack) {
   
    ///////////////////////////////////////		CLEAR EXISTING PARTS AND TEST EQUIP	///////////////////////////////////////
    this.saveTicketParts();
    var CLEARTICKETTESTEQUIP = { ticketId: this.formFields.TicketId };
    this._ticketService.clearTicketTestEquip(JSON.stringify({CLEARTICKETTESTEQUIP})).subscribe((Result: any) => {
      if (Result != null) {      
          if(this.formFields.istestEquipUsedRadio=='yes'){
            if(this.formFields.testEquipmentUsedDuringRepair!=undefined && this.formFields.testEquipmentUsedDuringRepair!=null)
            {
            this.saveTicketTestEquip();
          }
          
        }
      }
      else {
        this._messageService.showAlertMessage('Error clearing test equip before save.');
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );
    // ///////////////////////////////////////		SAVE THE TICKET QUESTION	///////////////////////////////////////
    if (this.formFields.selectedQuestionId > 0 && this.formFields.selectedQuestionId != null) {
      var SAVETICKETQUESTION = {
        ticketId: this.formFields.TicketId,
        questionId: this.formFields.selectedQuestionId,
        responseComment: this.formFields.responseComment,
        userId:this.userid

      };
      this._ticketService.saveTicketQuestion(JSON.stringify({SAVETICKETQUESTION})).subscribe((Result: any) => {
        if (Result.length > 0) {
          this.saveTicketTestEquip();
        }
        else {
          this._messageService.showAlertMessage('Error clearing test equip before save.');
        }
      },
        (respose: Response) => {
          // handle error here
        }
      );
    }

    // ///////////////////////////////////////		SAVE THE TICKET		///////////////////////////////////////
    var UPDATETICKET = {
      "UPDATETICKET":
      {
        ticketId: this.formFields.TicketId,
        UserID: Number( this.userid),
        "TICKETFIELDS": {
          workTypeId: this.formFields.selectedWorkTypeId==null?0:this.formFields.selectedWorkTypeId,
          isScheduledFlag: this.formFields.ScheduledRadioButtonselectedValue == 'no' ? 0 : this.formFields.ScheduledRadioButtonselectedValue == 'yes' ? 1 : 0,
          serviceRequested: this.formFields.serviceRequested==null?"":this.formFields.serviceRequested,
          SQACodeId: this.formFields.selectedSQACodeId==0?"":this.formFields.selectedSQACodeId==null?"":this.formFields.selectedSQACodeId,
          sqaSubCodeId: this.formFields.selectedSQASubCodeId==0?"": this.formFields.selectedSQASubCodeId==null?"":this.formFields.selectedSQASubCodeId,
          dateServiceRequested: this.formFields.srRequestedDate==null?'':this.formFields.srRequestedDate,
          dateServiceBegan: this.formFields.srBeginDate==null?'':this.formFields.srBeginDate,
          dateServicePerformed: this.formFields.srCompletedDate==null?'':this.formFields.srCompletedDate,
          clockHours: this.formFields.clockHours==null?0:this.formFields.clockHours,
          payrollCodeId: this.formFields.selectedpayRollId==null?"":this.formFields.selectedpayRollId==0?"":this.formFields.selectedpayRollId,
          hoursWork: this.formFields.hoursWorkedSel+'.'+this.formFields.minutesWorkedSel,
          hoursTravel: this.formFields.hoursTravelSel+'.'+this.formFields.minutesTravelSel,
          findings: this.formFields.findings==null?"":this.formFields.findings,
          workPerformed: this.formFields.workPerformed==null?"":this.formFields.workPerformed,
          isServiceMatchFindingsFlag: this.formFields.isServiceMatchFindingsFlag =='no'?0: this.formFields.isServiceMatchFindingsFlag == 'yes' ? 1 : 0,
          isBatchFlag: this.formFields.isCanBatchFlag==true?1:0,
          isCloneFlag: this.formFields.isCloneFlag==true?1:0,
          equipmentId: this.formFields.SelectedEquipmentID
        }
      }
    };
    this._ticketService.updateTicket(JSON.stringify(UPDATETICKET)).subscribe((Result: any) => {
      this.getTicketDatails(this.formFields.TicketId,(objTicket:TicketDetails)=>
      {
        this.formFields.ticketSavedByFirstLastName=objTicket?objTicket.fullnamefirstlast:this.formFields.ticketSavedByFirstLastName;
        if (msg) 
        {
          this._messageService.showAlertMessage('Success:Ticket Saved.');
        }
        if(fnTicketSaveCallBack!=null && fnTicketSaveCallBack!=undefined)
        {
          fnTicketSaveCallBack(true)
        }
      });
    },
      (respose: Response) => {
        fnTicketSaveCallBack(false)
        // handle error here
      }
    );
  }
  public saveTicketParts() {
    var savePartObj = this.formFields.partsUsedDuringRepair;
    let objTicketParts:any[]=[];
   if(savePartObj)
   {
      for (let i = 0; i < savePartObj.length; i++) 
      {
          var objPart = 
          {
            ticketId: this.formFields.TicketId,
            quantity: savePartObj[i].quantity,
            partId: savePartObj[i].partId,
            unitCost: savePartObj[i].unitCost,
            originalUnitCost: savePartObj[i].originalUnitCost == undefined ? 0 : savePartObj[i].originalUnitCost,
            dateOfInstall: savePartObj[i].dateOfInstall,
            isReplacingWarrantyPartFlag: savePartObj[i].isReplacingWarrantyPartFlag == false ? 0 : savePartObj[i].isReplacingWarrantyPartFlag==true?1:0,
            rgaNumber: savePartObj[i].rgaNumber == undefined ? null : savePartObj[i].rgaNumber,
            ticketPartSourceId:savePartObj[i].ticketPartSourceId,
            isRGAQualifiedFlag: savePartObj[i].isRGAQualifiedFlag == false ? 0 : savePartObj[i].isRGAQualifiedFlag == true?1:0,
          }
          objTicketParts.push(objPart);
      }
   }
    if( objTicketParts && objTicketParts.length>0)
    {
      var ADDTICKETPART=objTicketParts
      this._ticketService.addTicketPart(JSON.stringify({ ADDTICKETPART })).subscribe((Result: any) => {
        if (Result !=null) {} 
        else 
        {
          this._messageService.showAlertMessage('Part update failed.');
        }
      },
      (error) => 
      {
          // handle error here
      });
    }
  }
  public saveTicketTestEquip() {
    var saveTestEquipObj = this.formFields.testEquipmentUsedDuringRepair;
    for (let i = 0; i < saveTestEquipObj.length; i++) {
      var ADDTICKETTESTEQUIP = {
        ticketId: this.formFields.TicketId,
        TestEquipmentID: saveTestEquipObj[i].equipmentId
      }
      this._ticketService.addTicketTestEquip(JSON.stringify({ ADDTICKETTESTEQUIP })).subscribe((Result: any) => {
        if (Result.length == 0) {

        } else {
          this._messageService.showAlertMessage('Test Equipment update failed.');
        }
      },
        (respose: Response) => {
          // handle error here
        }
      );

    }
  }
  public voidClosedTicket() {
    var voided = false;
    var VOIDCLOSEDTICKET = {
      ticketId: this.formFields.TicketId,
      VoidReason: this.formFields.voidClosedReason,
      isCloneFlag: this.formFields.voidCloseClone==true?1:0,
      UserID:this.userid
    };
    this._ticketService.voidClosedTicket(JSON.stringify({ VOIDCLOSEDTICKET })).subscribe((Result: any) => {
      if (Result != null) 
      {
         voided = true;
         this._messageService.showAlertMessage('Ticket Successfully Voided');
          this.router.navigate(['/dashboard']);
      
      } else 
      {
        this._messageService.showAlertMessage('Error voiding ticket ' + this.formFields.TicketId);
      }
    },
      (respose: Response) => {
        // handle error here
      }
    );
    return voided;
  }
  public saveBatchTicket(Showmsg,callBack) {
    var newTicket = "";
    var msg = "";
    var i = 0;
    var errors = new Array();
    var batchXML = '';
    var isValid = false;

    // saveElecSafetyValues();
    // saveWaterValues();
   let hoursWork=this.formFields.hoursWorkedSel+this.formFields.minutesWorkedSel;
   let hoursTravel=this.formFields.hoursTravelSel+this.formFields.minutesTravelSel;

    let batchid = this.formFields.batchDetails.BatchId;
    var equipCount = 0;
    hoursWork = hoursWork / this.formFields.selectedBatchEquipmentList.length;
    hoursTravel = hoursTravel / this.formFields.selectedBatchEquipmentList.length;
    let BATCHTICKETOBJ = {
        facilityMasterId: this.formFields.selectedFacilityId,
        isScheduledFlag: this.formFields.ScheduledRadioButtonselectedValue=='yes'?1:null,
        isUnscheduledFlag: this.formFields.ScheduledRadioButtonselectedValue=='no'?0:null,
        workTypeId: this.formFields.selectedWorkTypeId,
        isBatchFlag: 1,
        isCloneFlag: 0,
        dateServiceRequested:this.formFields.srRequestedDate,
        dateServiceBegan: this.formFields.srBeginDate,
        dateServicePerformed:this.formFields.srCompletedDate,
        hoursWork: this.formFields.hoursWorkedSel+'.'+this.formFields.minutesWorkedSel,
        hoursTravel: this.formFields.hoursTravelSel+'.'+this.formFields.minutesTravelSel,
        payrollCodeId: this.formFields.batchDetails.payrollCodeId==0?null:this.formFields.batchDetails.payrollCodeId==null?null:this.formFields.batchDetails.payrollCodeId,
        sqaCode: this.formFields.batchDetails.SQACodeId==0?null:this.formFields.batchDetails.SQACodeId==null?null:this.formFields.batchDetails.SQACodeId,
        sqaSubCodeId: this.formFields.batchDetails.SQASubCodeId==0?null:this.formFields.batchDetails.SQASubCodeId==null?null:this.formFields.batchDetails.SQASubCodeId,
        ticketStatusId: 1,
        isServiceMatchFindingsFlag: 1,
        serviceRequested: this.formFields.serviceRequested,
        findings: this.formFields.findings,
        workPerformed:this.formFields.workPerformed,
        meritComplaint: 0,
        equipmentId:this.formFields.selectedBatchEquipmentList.map(x=>x.EquipmentID.toString()),
        electricalLeakage: this.formFields.batchTicketObj.map(x=>x.electricalLeakage),
        groundWireResistance: this.formFields.batchTicketObj.map(x=>x.groundWireResistance),
        clockHours: this.formFields.selectedWorkTypeName.toLowerCase()=="electrical safety"?this.formFields.batchTicketObj.map(x=>x.clockHours): this.formFields.selectedBatchEquipmentList.map(x=>x.clockhours),
        ticketId: this.formFields.batchTicketObj.map(x=>x.ticketId),
        ticketNumber: this.formFields.batchTicketObj.map(x=>x.ticketNumber),
        equipmentSerialNumber: this.formFields.selectedBatchEquipmentList.map(x=>x.EquipmentSerialNumber.toString()),
        manufacturerName: this.formFields.selectedBatchEquipmentList.map(x=>x.ManufacturerName.toString()),
        modelDescription: this.formFields.selectedBatchEquipmentList.map(x=>x.ModelDescription.toString()),
        ticketCount: this.formFields.selectedBatchEquipmentList.length,
        hoursWorkPerTicket: 0,
        hoursTravelPerTicket: 0,
        totalHoursPerTicket: 0,
        additionalComments: this.formFields.additionalComment,
        batchId: batchid,
        waterVolume:this.formFields.batchTicketObj.map(x=>x.waterVolume),
        waterDurationA: this.formFields.batchTicketObj.map(x=>x.waterDurationA),
        waterDurationB: this.formFields.batchTicketObj.map(x=>x.waterDurationB),
        waterDurationC: this.formFields.batchTicketObj.map(x=>x.waterDurationC),
        waterDurationD: this.formFields.batchTicketObj.map(x=>x.waterDurationD),
        waterDurationE: this.formFields.batchTicketObj.map(x=>x.waterDurationE),
        waterFrequency: this.formFields.batchTicketObj.map(x=>x.waterFrequency),
        waterVolumeMonthly: this.formFields.batchTicketObj.map(x=>x.waterVolumeMonthly),
        waterTemperatureVolume: this.formFields.batchTicketObj.map(x=>x.waterTemperatureVolume),
        waterTemperature: this.formFields.batchTicketObj.map(x=>x.waterTemperature),
        networkSurveyA: this.formFields.batchTicketObj.map(x=>x.networkSurveyA),
        networkSurveyB: this.formFields.batchTicketObj.map(x=>x.networkSurveyB),
        networkSurveyC: this.formFields.batchTicketObj.map(x=>x.networkSurveyC),
        networkSurveyD: this.formFields.batchTicketObj.map(x=>x.networkSurveyD),
        networkSurveyE: this.formFields.batchTicketObj.map(x=>x.networkSurveyE),
        covidAttestationA: this.formFields.batchTicketObj.map(x=>x.covidAttestationA),
        covidAttestationB: this.formFields.batchTicketObj.map(x=>x.covidAttestationB),
        covidAttestationC: this.formFields.batchTicketObj.map(x=>x.covidAttestationC),
        //software versions
        generalsoftware: this.formFields.batchTicketObj.map(x=>x.GeneralSoftware),
        actuator: this.formFields.batchTicketObj.map(x=>x.Actuator),
        functional: this.formFields.batchTicketObj.map(x=>x.Functional),
    };

    if (BATCHTICKETOBJ.isScheduledFlag == undefined) {
        BATCHTICKETOBJ.isScheduledFlag = null;
    }
    if (BATCHTICKETOBJ.isUnscheduledFlag == undefined) {
        BATCHTICKETOBJ.isUnscheduledFlag = null;
    }
    if (BATCHTICKETOBJ.workTypeId == undefined) {
        BATCHTICKETOBJ.workTypeId = null;
    }
    if (BATCHTICKETOBJ.payrollCodeId == undefined) {
        BATCHTICKETOBJ.payrollCodeId = null;
    }
    if (BATCHTICKETOBJ.sqaCode == undefined) {
        BATCHTICKETOBJ.sqaCode = null;
    }
    if (BATCHTICKETOBJ.sqaSubCodeId == undefined) {
        BATCHTICKETOBJ.sqaSubCodeId = null;
    }
    if (BATCHTICKETOBJ.additionalComments == undefined) {
        BATCHTICKETOBJ.additionalComments = null;
    }
   
    BATCHTICKETOBJ.hoursWorkPerTicket = Number(BATCHTICKETOBJ.hoursWork) / Number(BATCHTICKETOBJ.ticketCount);
    BATCHTICKETOBJ.hoursTravelPerTicket = Number(BATCHTICKETOBJ.hoursTravel) / Number(BATCHTICKETOBJ.ticketCount);
    BATCHTICKETOBJ.totalHoursPerTicket = BATCHTICKETOBJ.hoursWorkPerTicket + BATCHTICKETOBJ.hoursTravelPerTicket;

    var isValid =this._ticketValidate.validateBatchTicket(BATCHTICKETOBJ);
    var obj = {
        USERID: this.userid.toString(),
        TICKETFIELDS: JSON.stringify(BATCHTICKETOBJ)
    }
    var CREATEBATCHTICKET = {
        CREATEBATCHTICKET: obj
    };

    if (isValid) {
      this._ticketService.CreateBatchTicket(JSON.stringify(CREATEBATCHTICKET)).subscribe((Result: any) => {
        if (Result != null) {
            this.formFields.batchTicketObj = Result;		// replace existing object with updated results from db	
            let id=this.formFields.batchTicketObj.length>0?this.formFields.batchTicketObj[0].ticketId:0;
            this.getTicketDatails(id,(objTicket?:TicketDetails)=>
            {
              this.formFields.isShowBatchTicketSummary=true;
              this.formFields.ticketSavedByFirstLastName=objTicket?objTicket.fullnamefirstlast:this.formFields.ticketSavedByFirstLastName;
            });
            callBack(true);
        }
        else{
          callBack(false);
          this._messageService.showAlertMessage('Cannot create batch tickets. Please try again');
        }
      },
        (respose: Response) => {
          // handle error here
          callBack(false);
        }
      );
    }
    else
    {
      callBack(false);
    }
  }
  public getTicketDatails(ticketId,callBack) {
    let tickObj: TicketDetails;
    let getTicketDetailParam =
    {
      "GETTICKET": {
        UserID: this.userInfo.userId,
        BartRoleID: this.userInfo.bartRoleId,
        TicketID: ticketId
      }
    }
    this._ticketService.getTicket(JSON.stringify(getTicketDetailParam)).subscribe(data => 
    {
      if (data != null && data.length > 0) {
        tickObj = data.find(x => x.ticketId == ticketId);
      }
      callBack(tickObj)
    },
    (error)=>{
      callBack(tickObj)
    });
  }
}
